module.exports = __webpack_public_path__ + "img/1.1775eb40.png";